module.exports = __webpack_public_path__ + "teqbahn-assets/media/George Handley.7a40b39a.jpg";